import React, { useMemo } from 'react';
import { Box, Text } from '@stitch-fix/mode-react';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';
import SizeGuideLinkAndModal from '../SizeGuide/SizeGuideLinkAndModal';
import './styles.module.scss';
import { useThirdPersonCopy } from './useThirdPersonCopy';
import { loadTranslations } from '../../../shared/i18n';
import translations from './translations.json';

const { useTranslation } = loadTranslations(translations, 'ProductSizes');

const ProductSizesForFixPreview = () => {
  const { t } = useTranslation();
  const [state] = useProductDetailsPageContext();
  const { translationContext, clientName } = useThirdPersonCopy();

  const currentSkuSize = useMemo(() => {
    return state.onRecommendedSizesTab
      ? state.recommendedSkuSizeLabel || ''
      : state.selectedSizeLabel || '';
  }, [
    state.onRecommendedSizesTab,
    state.recommendedSkuSizeLabel,
    state.selectedSizeLabel,
  ]);

  return (
    <Box styleName="size-title-container">
      <Box mb={1}>
        <Text height="short" family="medium" scale="3">
          Size:{' '}
        </Text>
        <Text height="short" family="regular" scale="3">
          {currentSkuSize}
          <Text height="standard" family="regular" scale="3" color="gray-45">
            &nbsp;
            {t('recommendationText.fixPreview', {
              context: translationContext,
              name: clientName,
            })}
          </Text>
        </Text>
      </Box>
      <SizeGuideLinkAndModal />
    </Box>
  );
};

export default React.memo(ProductSizesForFixPreview);
